import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import { Plus } from 'lucide-react';

function QuickAddScheduleDialog({ open, onClose, workCenter, date, onConfirm }) {
  const [form, setForm] = useState({
    step_name: '',
    finished_product_code: '',
    finished_product_name: '',
    specification: '',
    assigned_quantity: '',
    notes: '',
  });
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setForm({
        step_name: '',
        finished_product_code: '',
        finished_product_name: '',
        specification: '',
        assigned_quantity: '',
        notes: '',
      });
      setError('');
    }
  }, [open]);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
    setError('');
  };

  const handleConfirm = () => {
    const stepName = form.step_name.trim();
    const productCode = form.finished_product_code.trim();
    const qty = parseInt(form.assigned_quantity, 10);

    if (!stepName) {
      setError('请输入任务名称');
      return;
    }
    if (!productCode) {
      setError('请输入产品编号');
      return;
    }
    if (isNaN(qty) || qty < 1) {
      setError('数量必须大于等于 1');
      return;
    }

    onConfirm?.({
      step_name: stepName,
      finished_product_code: productCode,
      finished_product_name: form.finished_product_name.trim(),
      specification: form.specification.trim(),
      assigned_quantity: qty,
      notes: form.notes.trim(),
    });
  };

  const handleClose = () => {
    onClose?.();
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) handleClose(); }}>
      <DialogContent className="sm:max-w-[460px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Plus className="h-4 w-4" />
            快速添加任务
            {workCenter && (
              <span className="text-xs font-normal text-gray-500 ml-2">
                {workCenter.name} · {date}
              </span>
            )}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-2">
          <div className="space-y-2">
            <Label htmlFor="quick-step-name">任务名称</Label>
            <Input
              id="quick-step-name"
              value={form.step_name}
              onChange={handleChange('step_name')}
              placeholder="例如：数磨工序"
            />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-2">
              <Label htmlFor="quick-product-code">产品编号</Label>
              <Input
                id="quick-product-code"
                value={form.finished_product_code}
                onChange={handleChange('finished_product_code')}
                placeholder="产品编号"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="quick-product-name">产品名称</Label>
              <Input
                id="quick-product-name"
                value={form.finished_product_name}
                onChange={handleChange('finished_product_name')}
                placeholder="产品名称"
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="quick-specification">规格</Label>
            <Input
              id="quick-specification"
              value={form.specification}
              onChange={handleChange('specification')}
              placeholder="例如：D3.26*45*95"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="quick-quantity">数量（件）</Label>
            <Input
              id="quick-quantity"
              type="number"
              min={1}
              value={form.assigned_quantity}
              onChange={handleChange('assigned_quantity')}
              placeholder="请输入数量"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="quick-notes">备注</Label>
            <Textarea
              id="quick-notes"
              value={form.notes}
              onChange={handleChange('notes')}
              placeholder="可选备注..."
              rows={2}
              className="resize-none"
            />
          </div>

          {error && (
            <div className="text-xs text-red-600">{error}</div>
          )}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={handleClose}>取消</Button>
          <Button onClick={handleConfirm}>确认添加</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default QuickAddScheduleDialog;
